module.exports = __webpack_public_path__ + "img/ok_square_icon.448d6355.svg";